import styled from "styled-components"

const Wrap = styled.div`
    position: relative;
    display: flex;
    gap: 15px;
    background-color: #18e4ae;
    background-image: url("${process.env.PUBLIC_URL}/image/img_report_bg.png");
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;
    padding: 26px 24px 14px;

    .img-cont {
        width: 78px;
        height: 100px;
        border-radius: 8px;
        overflow: hidden;
        flex-shrink: 0;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transform: scale(1.2);
        }
    }
    .text-cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 16px;

        .name {
            height: 32px;
            font-size: 20px;
            font-weight: 600;
            line-height: 32px;
        }

        .key-value {
            .key {
                font-size: 14px;
                line-height: calc(16 / 10);
                color: #000;
            }
            .value {
                font-size: 16px;
                font-weight: 400;
                color: #000;
                line-height: calc(19.2 / 12);
                &::after {
                    content: "";
                    display: block;
                    width: 20px;
                    height: 20px;
                    margin-left: 5px;
                    background: {
                        repeat: no-repeat;
                        size: contain;
                    }
                }

                &.female {
                    &::after {
                        background-image: url("${process.env.PUBLIC_URL}/image/icn_female.svg")
                    }
                }
                &.male {
                    &::after {
                        background-image: url("${process.env.PUBLIC_URL}/image/icn_male.svg");
                    }
                }
            }
        }
    }

    .report-info {
        position: absolute;
        top: 13px;
        right: 26px;
        width: 177px;
        
        .key-value {
            display: block;
            .key {
                width: 55px;
                flex-shrink: 0;
            }
            .key,
            .value {
                display: inline-block;
                font-size: 11px;
                line-height: 15.4px;
                color: #fff;
                vertical-align: middle;
            }

            .value {
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 122px;

                &::before {
                    display: inline-block;
                    background-color: #e8f0ee;
                }
            }
        }
    }

    .logo {
        position: absolute;
        bottom: 12px;
        right: 26px;
        width: 146px;

        img {
            display: block;
            width: 100%;
        }
    }
`
export default function UserInfo({data}) {
    return (
        <Wrap>
            <div className="img-cont">
                <img src={data.profile_img} alt="" />
            </div>

            <div className="text-cont">
                <div className="name">{data.user_name}</div>

                <div className="key-value">
                    <span className="key">생년월일</span>

                    <span className={data.gender == "1" ? "value male" : data.gender == "2" ? "value female" : "value"}>{data.birth}</span>
                </div>
                <div className="key-value">
                    <span className="key">전화번호</span>

                    <span className="value">
                        {
                            data.phone ?
                            data.phone.substr(0, 3) + "-****-" + data.phone.substr(7, 4)
                            : "-"
                        }
                    </span>
                </div>
                <div className="left"></div>
            </div>

            <div className="report-info">
                <div className="key-value">
                    <span className="key">병원(센터명)</span>
                    <span className="value">{data.center_name}</span>
                </div>
                <div className="key-value">
                    <span className="key">측정일자</span>
                    <span className="value">{data.report_date}</span>
                </div>
                <div className="key-value">
                    <span className="key">리포트 NO</span>
                    <span className="value">{data.report_id}</span>
                </div>
            </div>

            <div className="logo">
                <img src={process.env.PUBLIC_URL + "/image/img_report_logo.png"} />
            </div>
        </Wrap>
    )
}